import { useEffect } from 'react';
import { useUser } from '../authentication';
import { sessionStorage } from '../../utils/storageUtils';
import { getAllUnpairedLicenses } from './api/getAllUnpairedLicenses';
import windowService from '../../services/windowService';
import { logger } from '../../utils/logger';

export const UnpairedLicenseCheck = () => {
  const { user } = useUser();

  useEffect(() => {
    if (user && !sessionStorage.getItem('checkedUnpairedLicenses')) {
      getAllUnpairedLicenses()
        .then(([groupLicenses]) => {
          if (groupLicenses.length > 0) {
            windowService.redirectTo('/pairing');
          }
        })
        .catch(error => {
          logger.error('Failed to check for unpaired licenses:', error);
        });
      sessionStorage.setItem('checkedUnpairedLicenses', true);
    }
  }, [user?.userId]);

  return null;
};
